import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";

const navLinks = [
  { href: "/", label: "Accueil" },
  { href: "/services", label: "Services" },
  { href: "/a-propos", label: "A propos" },
  { href: "/blog", label: "Blog" },
  { href: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/90 backdrop-blur-md border-b border-border/50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
          <span className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-foreground">
            2BW<span className="text-[#C5A065] ml-1">BAT</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <Link key={link.href} to={link.href} className={`nav-link text-sm tracking-widest uppercase font-medium transition-colors duration-300 ${location.pathname === link.href ? "text-[#C5A065]" : "text-foreground/70 hover:text-foreground"}`}>
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a href="tel:+33666777517" className="flex items-center gap-2 text-sm text-foreground/70 hover:text-[#C5A065] transition-colors" data-testid="navbar-phone">
            <Phone className="w-4 h-4" />
            06 66 77 75 17
          </a>
          <Link to="/contact">
            <Button className="bg-[#C5A065] text-white hover:bg-[#C5A065]/90 px-6 py-2 text-xs tracking-widest uppercase rounded-none" data-testid="navbar-cta">
              Devis gratuit
            </Button>
          </Link>
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon" data-testid="mobile-menu-trigger">
              <Menu className="w-6 h-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-background w-80">
            <SheetTitle className="font-heading text-xl mb-8">
              2BW<span className="text-[#C5A065] ml-1">BAT</span>
            </SheetTitle>
            <nav className="flex flex-col gap-6">
              {navLinks.map((link) => (
                <Link key={link.href} to={link.href} onClick={() => setOpen(false)} className={`text-base tracking-wide uppercase font-medium transition-colors ${location.pathname === link.href ? "text-[#C5A065]" : "text-foreground/70 hover:text-foreground"}`}>
                  {link.label}
                </Link>
              ))}
              <Link to="/contact" onClick={() => setOpen(false)}>
                <Button className="bg-[#C5A065] text-white hover:bg-[#C5A065]/90 w-full py-3 text-xs tracking-widest uppercase rounded-none mt-4" data-testid="mobile-cta">
                  Devis gratuit
                </Button>
              </Link>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
